import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get permission
export const getBranchPermission = createAsyncThunk(
  "branchPermission/getBranchPermission",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getBranchPermission({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all permission
export const getAllBranchPermission = createAsyncThunk(
  "branchPermission/getAllBranchPermission",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllBranchPermission();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("branchPermission/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("branchPermission/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "branchPermission/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageBranchPermission({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create permission
export const createBranchPermission = createAsyncThunk(
  "branchPermission/createBranchPermission",
  async (param, { rejectWithValue }) => {
    const { name, isActive } = param;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.createBranchPermission(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateBranchPermission = createAsyncThunk(
  "branchPermission/updateBranchPermission",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const { name, isActive } = values;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.updateBranchPermission(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("branchPermission/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
